<template>
	<form class="new-user-row" autocomplete="off">
		<ja-input
			v-model.trim="firstName"
			class="form-input"
			name="firstName"
			:label="$t('firstName')"
			required
			:max-length="constants.FIRST_NAME_MAX_LENGTH"
			autocomplete="off"
			:validation-check="validationCheck"
			@input="updateFormData"
		></ja-input>
		<ja-input
			v-model.trim="lastName"
			class="form-input"
			name="lastName"
			:label="$t('lastName')"
			required
			:max-length="constants.LAST_NAME_MAX_LENGTH"
			autocomplete="off"
			:validation-check="validationCheck"
			@input="updateFormData"
		></ja-input>
		<ja-input
			v-model.trim="email"
			class="form-input"
			value="email"
			name="email"
			:label="$t('email')"
			:max-length="constants.EMAIL_MAX_LENGTH"
			autocomplete="off"
			:validation-check="validationCheck"
			@input="updateFormData"
		></ja-input>
	</form>
</template>

<script>
import Input from '@/components/ui/form/Input';
import { studentsSources } from '@/helpers/constants';

export default {
	name: 'AddStudent',
	components: {
		jaInput: Input
	},
	props: {
		validationCheck: {
			type: Boolean,
			default: false
		},
		entityGuid: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			firstName: '',
			lastName: '',
			email: null
		};
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		}
	},
	methods: {
		updateFormData() {
			this.$emit('update', {
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
				entityGuid: this.entityGuid,
				source: studentsSources.FINANCE_PARK
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.new-user-row {
	padding-top: 32px;
	padding-bottom: 32px;
	.guid {
		display: none;
	}
}
.form-input {
	display: flex;
	flex-direction: column;
	margin-top: 16px;
	width: 240px;
}
.new-user-buttons {
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: 32px;
	button {
		margin-bottom: 16px;
	}
}
</style>
